import axios from 'axios';

export const userService = {
    listUsers,
	getUser,
	updateUser,
	updateUserPassword,
	setSharedUsersView,
	setManagedCustomers,
	getRaters,
	addRater,
	deleteRater,
	getRatings,
	getAllRatings,
	raterMorePriority
};

function listUsers() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/", {params: {}});
}

function getUser(id) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+id, {params: {}});
}

//function updateUser(userId, username, customer, oauthToken) {
function updateUser(user) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
//	let user = JSON.stringify({ userId: userId, username: username, customer: customer, role:"CUSTOMER" })
//	console.log('updateUser USER: '+JSON.stringify(user));
	if(user.id>0){
		return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+user.id+"/", JSON.stringify(user), headers);
	}else{
		return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/", JSON.stringify(user), headers);
	}
}
function updateUserPassword(userId, password) {
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	if(userId>0){
		return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+userId+"/updatePassword/", "{\"password\": \""+password+"\"}", headers);
	}
	return 0;
}

function setSharedUsersView(userId, sharedUserList){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+userId+"/setSharedUsersView/", sharedUserList, headers);
}

function setManagedCustomers(userId, managedCustomers){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/user/"+userId+"/setProjectManager/", managedCustomers, headers);
}

function getRatings(userId){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/rating/list/"+userId, {params: {}});
}

function getAllRatings(){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/rating/", {params: {}});
}

function getRaters(){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/rater/", {params: {}});
}

function addRater(langPair, user){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let raterDao={user:{id: user},languagePair: {id: langPair}, priority: 0}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/rater/", JSON.stringify(raterDao), headers);
}

function deleteRater(id){
	return axios.delete(process.env.REACT_APP_serverURL+"/documents-0.0.1/rater/"+id, {params: {}});
}

function raterMorePriority(raterId){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/rater/"+raterId+"/morePriority","{}", headers);
}